import React, { useState } from "react"
import PropTypes from "prop-types"
import { Steps, Button, Flex } from "antd"
import { FileTextOutlined, ShareAltOutlined, UserOutlined, FileDoneOutlined, CopyOutlined } from "@ant-design/icons"
import styles from "./index.module.css"
import CustomQuestions from "../modal/CustomQuestions"
import IconWithBg from "ui/IconWithBg"

const { Step } = Steps

const stepData = [
  {
    title: "Sign Your Waiver",
    desc: "Complete your waiver now to confirm your spot.",
    btn: "Sign Waiver",
    icon: <FileTextOutlined />
  },
  {
    title: "Share Waiver",
    desc: "Send the waiver link to any other participants.",
    btn: "Share Waiver",
    icon: <ShareAltOutlined />,
    copy: true
  },
  {
    title: "Answer Questions",
    desc: "Answer a few quick questions to help your Pro prepare the perfect trip for you and your group.",
    btn: "Answer Questions",
    icon: <UserOutlined />
  },
  {
    title: "Share Experience Details",
    desc: "Keep your group in the loop with all the trip information.",
    btn: "Share Trip",
    icon: <FileDoneOutlined />
  }
]

const Stepper = ({ current = 0, bookingQuestionnaireId }) => {
  const [activeStep, setActiveStep] = useState(current)
  const [showQuestions, setShowQuestions] = useState(false)

  const handleStepClick = (stepIndex) => {
    setActiveStep(stepIndex)
  }

  const handleAnswerQuestions = (e, idx) => {
    e.stopPropagation()
    setActiveStep(idx)
    setShowQuestions(true)
  }

  const handleCloseQuestions = () => {
    setShowQuestions(false)
  }

  return (
    <div className={styles.stepperContainer}>
      <Steps current={activeStep} labelPlacement="vertical" className={styles.antdStepper} progressDot={false}>
        {stepData.map((step, idx) => (
          <Step
            key={step.title}
            onClick={() => handleStepClick(idx)}
            className={`${styles.stepItem} ${activeStep === idx ? styles.activeStep : ""}`}
            icon={<span className={`${styles.iconWrapper} ${idx <= activeStep ? styles.active : styles.inactive}`}>{step.icon}</span>}
            title={
              <>
                <div className={styles.stepNumber}>Step {idx + 1}</div>
                <div className={styles.stepTitle}>{step.title}</div>
              </>
            }
            description={
              <>
                <div className={styles.stepDesc}>{step.desc}</div>
                <Flex items="center" justifyContent="center" gap={8}>
                  <Button
                    color="primary"
                    variant="solid"
                    className={styles.stepButton}
                    onClick={(e) => {
                      if (step.title === "Answer Questions") {
                        handleAnswerQuestions(e, idx)
                      } else {
                        e.stopPropagation()
                        handleStepClick(idx)
                      }
                    }}
                  >
                    {step.btn}
                  </Button>
                  {step.copy && (
                    <IconWithBg
                      icon={
                        <CopyOutlined
                          onClick={(e) => {
                            e.stopPropagation()
                          }}
                        />
                      }
                    ></IconWithBg>
                  )}
                </Flex>
              </>
            }
          />
        ))}
      </Steps>
      {showQuestions && (
        <CustomQuestions bookingQuestionnaireId={bookingQuestionnaireId} visible={showQuestions} onClose={handleCloseQuestions} />
      )}
    </div>
  )
}

Stepper.propTypes = {
  current: PropTypes.number,
  bookingQuestionnaireId: PropTypes.string
}

Stepper.defaultProps = {
  current: 0,
  bookingQuestionnaireId: ""
}

export default Stepper
